// extracted by mini-css-extract-plugin
export default {"base_avatar":"BaseAvatar_base_avatar_gBwB6","image":"BaseAvatar_image_J6KIg"};